import { useEffect } from 'react'

/**
 * Das Schriften-Stylesheet der jeweils betrachteten Organisation.
 *
 * Selbst gehostete Schriften gehören einer Organisation, das ausgelieferte
 * `@font-face`-CSS also auch. Der `<link>` steht fest in `index.html` — hier
 * wird nur sein Ziel umgehängt, sobald feststeht, wessen Board oder Übersicht
 * gerade offen ist. Ein zweiter `<link>` je Ansicht wäre schlechter: Beim
 * Wechsel zwischen zwei Organisationen blieben die Schriften der vorigen
 * geladen und stünden weiter zur Auswahl.
 *
 * Gäste durchlaufen denselben Weg mit der Organisation des Boards, das sie
 * sehen dürfen — sonst sähen sie den Vortrag in der falschen Schrift.
 */

const SELECTOR = 'link[data-fonts]'

let currentOrgId: string | null = null

function apply(orgId: string | null, bust = false): void {
  const link = document.querySelector<HTMLLinkElement>(SELECTOR)
  if (!link) return
  const base = orgId ? `/api/fonts.css?org=${encodeURIComponent(orgId)}` : '/api/fonts.css'
  // Der Zeitstempel nur beim ausdrücklichen Nachladen: Sonst umginge jeder
  // Seitenwechsel den Browser-Cache, und die Schriften flackerten.
  link.href = bust ? `${base}${orgId ? '&' : '?'}v=${Date.now()}` : base
}

export function useFontStylesheet(orgId: string | null | undefined): void {
  useEffect(() => {
    if (!orgId || orgId === currentOrgId) return
    currentOrgId = orgId
    apply(orgId)
  }, [orgId])
}

/**
 * Nach dem Holen einer neuen Schrift: Das Stylesheet ist bereits im Browser und
 * würde die frisch hinzugekommene Familie sonst erst nach einem Neuladen der
 * Seite kennen — die Vorschau bliebe leer.
 */
export function refreshFontStylesheet(): void {
  apply(currentOrgId, true)
}
